module.exports = __webpack_public_path__ + "img/page37.6a7240ab.gif";